<template>
  <div>

    <el-row class="small-title">
      {{$t("title.system.point.table.workOfficePointTotal")}}
      </el-row>

    <el-table
      :data="result"
      class="table-type">

      <!--  年月 -->
      <el-table-column
        label="有効期限"
        class-name="col-5">
          <template slot-scope="scope">
            {{formatMonth(scope.row.endDate)}}
          </template>
      </el-table-column>

      <!--  WorkOffice+ポイント残高 -->
      <el-table-column
        prop="WorkOfficeBalancePoint"
        class-name="col-3"
        :label="$t('title.system.point.table.WorkOfficePointBalance')"/>

      <!--  失効ポイント設定 -->

      <el-table-column class-name="col-5" :label="$t('title.system.point.table.invalidPointSetting')">
        <div slot-scope="scope" class="detail-button with-100">
          <div >
            <number-input-medium :value="scope.row.woPointChangeCount" @in_put="getInputNumber($event,scope.row)"/>
          </div>
        </div>
      </el-table-column>

      <!-- 失効処理後ポイント残高 -->
      <el-table-column
        class-name="col-3"
        :label="$t('title.system.point.table.afterInvalidBalance')">
        <div slot-scope="scope">
          <div >
            <span :class="{color: scope.row.woPointChangeCount > 0}">
              {{Number(scope.row.WorkOfficeBalancePoint) - Number(scope.row.woPointChangeCount) | pointDeal}}
            </span>
          </div>
        </div>
      </el-table-column>

    </el-table>
  </div>


</template>

<script>
// import SpSmartButton from "@/components/common/sp-smart-button"
import NumberInputMedium from "@/components/common/input/NumberInput"
const INVALID_EDIT = "on-invalid"

export default {
  components:{
  // SpSmartButton: SpSmartButton
  NumberInputMedium: NumberInputMedium
  },
  filters:{
    pointDeal(val){
      if(val < 0){
        return 0
      }
      return val
    }
  },
  created(){
  },
  methods: {
    getInputNumber(a,val){
      this.query.number = val.yearMonth
      this.$emit(INVALID_EDIT,this.query.number,a)
    },
    formatMonth(date){
      return this.$dateFullDayFormat(date) + 'まで'
    }
  },
  name: "CompanyWalletChargeSearchResultBeautify",
  data() {
    return {
      query: {
        number: 0
      },
    }
  },
  props: {
    result: Array,
    isShow: Boolean
  },
}
</script>

<style lang="scss" scoped>
.color {
  color: #329CA6;
}
.btn-operate-other {
  margin-left: 5px;
}
.search-result-wrapper {
  height: 300px;
  overflow-y: scroll;
}
::v-deep .cell {
  height: auto;
}
::v-deep .el-table .cell {
  padding-left: 0px;
}

.table-type {
  width: 100%;
}
.button_left {
  float: left;
  width: 80px;
  margin-right: 16px !important;
}
.button_right {
  float: left;
  width: 80px;
}

::v-deep .my-button {
  width: 100%;
  margin-left: 5px;
}

::v-deep .small-title{
  font-size: 16px;
  margin-bottom: 36px;
  color: #525250;
}
.invalidationPoints-type-type ::v-deep{
  .my-button {
    width: 188px;
  }
}
::v-deep .el-table td{
  padding-top: 15px !important;
  padding-bottom: 11px !important;
}
::v-deep .sp_unit{
  padding-top: 13px;
  padding-left: 12px;
}
</style>
